import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import imgReset from "assets/images/reset.png";
import imgLogo from "assets/images/logo.png";
import { Card, CardBody, Col, Container, Row, Spinner } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
// Redux
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import "./login.scss";
import { API_BASE_URL_ENV } from "helpers/common";
import { toast } from "react-toastify";

const apiResetPasswordEndpoint =
  API_BASE_URL_ENV() + "/website/user/reset-password";

const ResetPassword = (props) => {
  const [showPassword, setShowPassword] = useState(true)
  const [showConfirmPassword, setShowConfirmPassword] = useState(true)
  const [password, setPassword] = useState("")
  const [Confirmpassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const handleValidSubmit = async (event, values) => {
    if (values.password !== values.password_confirmation) {
      toast.error("Password Confirmation doesnot match Password")
      return
    }
    setLoading(true)
    await AuthService.resetPassword(apiResetPasswordEndpoint, values).then(
      (res) => {
        toast.success("Reset Password successfully")
        props.history.push(`/`);

      },
    ).catch(e => {
      setLoading(false)
    })
  };

  return (
    <React.Fragment>
      <MetaTags>
        <title>Reset Password</title>
      </MetaTags>
      <div className='account-pages'>
        <div className="bgImage">
          <Container fluid>
            <Row className='justify-content-center text-left' dir='rtl'>
              <Col md={8} lg={7} xl={6} className='p-lg-0 p-md-0' dir='ltr'>
                <Card className='overflow-hidden mt-5 mb-0'>
                  <CardBody className="text-center">
                    <img src={imgLogo} className='mt-3' />
                    <p className='fw-bold font-size-18 fw-bold pt-2 mb-2'>Assign A New Password</p>
                    <p className="textMuted font-size-13">Use you email address and password to can login</p>
                    <div className='pt-4 p-2 pb-3'>
                      <AvForm
                        className='form-horizontal formWithLabel'
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v);
                        }}>
                        {/* <div className='mb-3'>
                          <AvField
                            name='code'
                            label='Forget Password Code'
                            className='form-control'
                            placeholder='Code Password'
                            type='text'
                            required
                          />
                        </div> */}
                        <div className='mb-3'>
                          <AvField
                            name='code'
                            id='code'
                            label='Code'
                            className='form-control'
                            placeholder='Type Code'
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            readOnly
                            onFocus={() => document.getElementById("code").removeAttribute('readonly')}
                          />
                        </div>
                        <div className='mb-3 position-relative'>
                          <AvField
                            name='password'
                            id='password'
                            label='Password'
                            className='form-control'
                            placeholder='Type Password'
                            //type='password'
                            type={showPassword ? 'password' : "text"}
                            required
                            readOnly
                            onChange={(e) => setPassword(e.target.value)}
                            onFocus={() => document.getElementById("password").removeAttribute('readonly')}
                          />
                          <div style={{
                            position: "absolute",
                            top: "12px",
                            right: "10px",

                          }} onClick={() => setShowPassword(!showPassword)} >
                            {password.trim().length !== 0 ? showPassword ?
                              <i className="fas fa-eye-slash"></i>
                              :
                              <i className="fas fa-eye  "></i>
                              : null}
                          </div>
                        </div>
                        <div className='mb-3 position-relative'>
                          <AvField
                            name='password_confirmation'
                            id='password_confirmation'
                            label='Re-Type Password'
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            className='form-control'
                            placeholder='Re-Type Password'
                            type={showConfirmPassword ? 'password' : "text"}
                            onFocus={() => document.getElementById("password_confirmation").removeAttribute('readonly')}
                            required
                            readOnly
                          />
                          <div style={{
                            position: "absolute",
                            top: "12px",
                            right: "10px",

                          }} onClick={() => setShowConfirmPassword(!showConfirmPassword)} >
                            {Confirmpassword.trim().length !== 0 ? showConfirmPassword ?
                              <i className="fas fa-eye-slash"></i>
                              :
                              <i className="fas fa-eye  "></i>
                              : null}

                          </div>
                        </div>

                        <div className='mt-4 d-grid'>
                          {loading ? <div className="m-auto btnHeight">
                            <Spinner
                              color="success"
                            >
                            </Spinner>
                          </div> : <button
                            className='btn btn-success w-100 btnHeight'
                            type='submit'>
                              Change Password
                          </button>}
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword;
